import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { AlertCircle } from "lucide-react";
import { Card, CardContent } from "../components/ui/card";
import { LandingPageView } from "../components/LandingSections";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const BACKEND_HOST = BACKEND_URL;

function setMeta(name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}
function setOg(prop, content) {
  if (!content) return;
  let el = document.querySelector(`meta[property="${prop}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", prop);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function LandingPublic() {
  const { slug } = useParams();
  const [state, setState] = useState({ loading: true, data: null, error: null });

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/public/landing/${slug}`)
      .then((r) => setState({ loading: false, data: r.data, error: null }))
      .catch((e) => setState({
        loading: false, data: null,
        error: e.response?.status === 404 ? "notfound" : "error",
      }));
  }, [slug]);

  useEffect(() => {
    if (!state.data) return;
    const { page, og_image_url } = state.data;
    const seo = page.seo || {};
    const title = seo.title || page.title || "";
    const desc = seo.description || "";
    document.title = title;
    setMeta("description", desc);
    setOg("og:title", title);
    setOg("og:description", desc);
    setOg("og:type", "website");
    if (og_image_url) {
      const abs = og_image_url.startsWith("http") ? og_image_url : `${BACKEND_URL}${og_image_url}`;
      setOg("og:image", abs);
    }
  }, [state.data]);

  if (state.loading) {
    return <div className="min-h-screen grid place-items-center bg-slate-900 text-slate-400" data-testid="landing-loading">Lade Seite…</div>;
  }

  if (state.error === "notfound") {
    return (
      <div className="min-h-screen grid place-items-center bg-slate-900 text-slate-200 p-6" data-testid="landing-notfound">
        <Card className="max-w-md w-full bg-slate-800 border-slate-700">
          <CardContent className="p-8 text-center">
            <AlertCircle className="h-10 w-10 text-amber-400 mx-auto mb-4" />
            <h1 className="text-2xl font-extrabold tracking-tight">Seite nicht gefunden</h1>
            <p className="text-sm text-slate-400 mt-3">
              Diese Seite ist nicht (mehr) verfügbar. Bitte prüfe den Link oder kontaktiere uns.
            </p>
          </CardContent>
        </Card>
      </div>
    );
  }

  if (state.error) {
    return <div className="min-h-screen grid place-items-center bg-slate-900 text-slate-200">Fehler beim Laden.</div>;
  }

  const { page, products } = state.data;

  const onLeadSubmit = async (form) => {
    const payload = {
      name: form.name, email: form.email,
      phone: form.phone || "", message: form.message || "",
      consent: !!form.consent, website: form.website || "",
    };
    try {
      await axios.post(`${BACKEND_URL}/api/public/landing/${slug}/leads`, payload);
    } catch (e) {
      throw new Error(e.response?.data?.detail || "Bitte erneut versuchen.");
    }
  };

  return (
    <LandingPageView
      page={page}
      products={products}
      theme={page.theme}
      backendHost={BACKEND_HOST}
      leadForm={page.lead_form}
      onLeadSubmit={onLeadSubmit}
      isPreview={false}
    />
  );
}
